import React, { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { certificates as endpoints } from '@URLS'
import { routePaths, linkPaths, OBJECT_ID, COURSENUM } from '../urls'
import { Requirements } from './Requirements'
import { Design } from './Design'
import { Review } from './Review'

export const App = () => {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    if (OBJECT_ID && !state.certInfo.retrievedEditData) {
      const fetchCertInfo = async () => {
        const url = endpoints.show({ id: OBJECT_ID })
        try {
          const response = await client.get(url)
          dispatch({
            type: 'UPDATE_CERT_INFO',
            payload: { ...response.data, retrievedEditData: true },
          })
        } catch (err) {
          console.error(`Error fetching ${url}`, err)
        }
      }
      fetchCertInfo()
    }
  }, [])

  useEffect(() => {
    if (state.finished) {
      window.location = `/instructor/achievements/${COURSENUM}/`
    }
  }, [state.finished])

  return (
    <div
      id="body_section"
      className="row position-relative p-0 my-5 mx-3 mx-sm-5"
    >
      <section id="body_section_center" className="border bg-light m-0 pt-3">
        <Switch>
          <Route path={routePaths.design} component={Design} />
          <Route path={routePaths.requirements} component={Requirements} />
          <Route path={routePaths.review} component={Review} />
          <Redirect from={routePaths.wizard} to={linkPaths.design} />
        </Switch>
      </section>
    </div>
  )
}
